import React from 'react';
import styles from './Maps.scss';

export function CustomerIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="32"
      viewBox="0 0 25 32"
      style={{ position: 'relative', top: '-20px', right: '20px' }}
    >
      <defs>
        <filter id="a" width="148.9%" height="301.7%" x="-24.5%" y="-100.9%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".75" />
        </filter>
        <filter id="b" width="246.7%" height="402.6%" x="-73.4%" y="-151.3%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".75" />
        </filter>
        <ellipse id="c" cx="10.629" cy="10.095" rx="9.967" ry="9.667" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)">
          <g fill="#162D3D" transform="translate(6.9 26.77)">
            <ellipse cx="4.6" cy="1.115" filter="url(#a)" opacity=".3" rx="4.6" ry="1.115" />
            <ellipse cx="4.6" cy=".744" filter="url(#b)" opacity=".8" rx="1.533" ry="1" />
          </g>
          <path
            fill="#E05050"
            stroke="#FFF"
            d="M18.338 20.833L11.5 27.466l-.348-.338-6.452-6.27a11.641 11.641 0 0 1-5.2-9.704C-.5 4.718 4.718-.5 11.154-.5h.692C18.282-.5 23.5 4.718 23.5 11.154c0 3.93-1.961 7.529-5.162 9.68z"
          />
          <rect width="16.867" height="16.359" x="3.067" y="2.974" fill="#FFF" rx="8.179" />
        </g>
        <g transform="translate(1.87 2.059)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <ellipse cx="10.629" cy="19.762" fill="#E05050" mask="url(#d)" rx="6.9" ry="6.692" />
          <ellipse cx="10.629" cy="8.608" fill="#E05050" mask="url(#d)" rx="3.833" ry="3.718" />
        </g>
      </g>
    </svg>
  );
}

export function RestPinIconUnselected(props) {
  return (
    <svg
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="62"
      viewBox="0 0 59 62"
      className={styles.marker}
      // style={{ position: 'relative', top: '-30px', right: '30px' }}
    >
      <defs>
        <filter id="a" width="148.9%" height="301.7%" x="-24.5%" y="-100.9%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".75" />
        </filter>
        <filter id="b" width="246.7%" height="402.6%" x="-73.4%" y="-151.3%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".75" />
        </filter>
        <rect id="c" width="16" height="16" x="3" y="3" rx="8" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g fill="#162D3D" transform="translate(6.9 26.77)">
          <ellipse cx="4.6" cy="1.115" filter="url(#a)" opacity=".3" rx="4.6" ry="1.115" />
          <ellipse cx="4.6" cy=".744" filter="url(#b)" opacity=".8" rx="1.533" ry="1" />
        </g>
        <path
          fill="#577083"
          d="M11.5 0C17.851 0 23 5.149 23 11.5c0 3.92-1.962 7.383-4.958 9.459L12 27l-6.199-5.509A11.496 11.496 0 0 1 0 11.5C0 5.149 5.149 0 11.5 0z"
        />
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <use fill="#FFF" xlinkHref="#c" />
        <path
          fill="#577083"
          d="M10.35 6.692c.212 0 .383.172.383.384v5.565c0 .821-.643 1.487-1.437 1.487H9.2v6.31a.383.383 0 0 1-.767 0v-6.31h-.095c-.794 0-1.438-.666-1.438-1.487V7.076a.383.383 0 1 1 .767 0l-.001 4.077h.767V7.076a.383.383 0 1 1 .767 0v4.077h.766V7.076c0-.212.172-.384.384-.384zm4.585 0h.015c.212 0 .383.172.383.384v12.618a.383.383 0 1 1-.766 0l-.001-3.337h-1.788a.526.526 0 0 1-.511-.539V10.43c0-1.832.763-3.358 2.37-3.7l.19-.035a.443.443 0 0 1 .108-.002z"
          mask="url(#d)"
        />
      </g>
    </svg>
  );
}

export function RestPinIconSelected(props) {
  return (
    <svg
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="62"
      viewBox="0 0 59 62"
      className={styles.marker}
      style={{ position: 'relative', top: '-30px', right: '30px' }}
    >
      <defs>
        <filter id="a" width="148.9%" height="301.7%" x="-24.5%" y="-100.9%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".75" />
        </filter>
        <filter id="b" width="246.7%" height="402.6%" x="-73.4%" y="-151.3%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".75" />
        </filter>
        <path
          id="d"
          d="M18.038 20.962L12 27l-6.196-5.507A11.496 11.496 0 0 1 0 11.5C0 5.149 5.149 0 11.5 0S23 5.149 23 11.5c0 3.922-1.964 7.386-4.962 9.462z"
        />
        <filter id="c" width="395.7%" height="353.2%" x="-147.8%" y="-81.5%" filterUnits="objectBoundingBox">
          <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="shadowSpreadOuter1" />
          <feOffset dy="12" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="9" />
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0"
          />
          <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="shadowSpreadOuter2" />
          <feOffset dy="1" in="shadowSpreadOuter2" result="shadowOffsetOuter2" />
          <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="1.5" />
          <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
          <feColorMatrix
            in="shadowBlurOuter2"
            result="shadowMatrixOuter2"
            values="0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="shadowMatrixOuter2" />
          </feMerge>
        </filter>
        <rect id="e" width="16" height="16" x="3" y="3" rx="8" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(18 6)">
        <g fill="#162D3D" transform="translate(6.9 26.77)">
          <ellipse cx="4.6" cy="1.115" filter="url(#a)" opacity=".3" rx="4.6" ry="1.115" />
          <ellipse cx="4.6" cy=".744" filter="url(#b)" opacity=".8" rx="1.533" ry="1" />
        </g>
        <g strokeLinecap="square">
          <use fill="#000" filter="url(#c)" xlinkHref="#d" />
          <path
            fill="#E05050"
            stroke="#FFF"
            d="M18.36 21.347l-6.34 6.34L5.51 21.9A11.994 11.994 0 0 1-.5 11.5c0-6.627 5.373-12 12-12s12 5.373 12 12c0 3.972-1.945 7.617-5.14 9.847z"
          />
        </g>
        <mask id="f" fill="#fff">
          <use xlinkHref="#e" />
        </mask>
        <use fill="#FFF" xlinkHref="#e" />
        <path
          fill="#E05050"
          d="M14.567 16.357h-1.79a.526.526 0 0 1-.51-.539V10.43c0-1.902.823-3.475 2.56-3.735a.443.443 0 0 1 .123-.003c.212 0 .383.172.383.384v12.618a.383.383 0 1 1-.766 0v-3.337zm-3.834-5.203v1.487c0 .821-.643 1.487-1.437 1.487H9.2v6.31a.383.383 0 0 1-.767 0v-6.31h-.095c-.794 0-1.438-.666-1.438-1.487V7.076a.383.383 0 1 1 .767 0v4.078h.766V7.076a.383.383 0 1 1 .767 0v4.078h.767V7.076a.383.383 0 1 1 .766 0v4.078z"
          mask="url(#f)"
        />
      </g>
    </svg>
  );
}
